module.exports = __webpack_public_path__ + "img/realshield-logo-white.fe3cd169.png";